import setupQuasar from '@src/plugins/quasar'
import setupApexCharts from '@src/plugins/apexCharts'
import setupEcharts from '@src/plugins/echarts'
import setupVuePrint from '@src/plugins/vuePrint'
import pinia from '@src/plugins/pinia'
import i18n from '@src/plugins/i18n'
import router from '@src/plugins/router'
import type { App } from 'vue'

// Run setup function for every module
import { setups } from '@src/modules'
import sanitizeHtml from '@src/libs/sanitizeHtml'

export default function (app: App) {
    // Manter ordem abaixo

    app.use(pinia).use(i18n)

    window.updateRouter()

    app.use(router)

    router.push({
        path: window.location.pathname,
        query: {
            ...Object.fromEntries(
                // @ts-ignore
                new URLSearchParams(window.location.search)
            ),
            root: 'true',
        },
    })
    setups.forEach((setup) => {
        setup.import({ pinia, router, i18n, app })
    })

    setupQuasar(app)
    setupApexCharts(app)
    setupEcharts(app)
    setupVuePrint(app)

    app.directive('safeHtml', sanitizeHtml)
    return { router, pinia, i18n }
}
